import axiosSso from "@/api/interceptor_sso";

// 二代列表
export function getAgent2(params?: any) {
  return axiosSso.get("/agent/agents/agent2", { params });
}

// 免密登录
export function postAgentSafeLogin(data: any) {
  return axiosSso.post(`/agent/agents/${data.id}/safe-login`, data);
}

// 查看
export function getDouyinAgentsId(id: any) {
  return axiosSso.get(`/agent/agents/${id}`);
}

// 开户
export function agentCreate(data: any) {
  return axiosSso.post("/agent/agents", data);
}

// 编辑
export function putDouyinAgents(data: any) {
  return axiosSso.put(`/agent/agents/${data.id}`, data);
}

// 重置密码
export function putRestsPwd(data: any) {
  return axiosSso.put(`/agent/agents/${data.id}/reset-password`, data);
}

/**
 * 查看初始密码
 * @param id
 * @param params
 */
export function getAgentAgentsPassword(id: any, params: any) {
  return axiosSso.get(`/agent/agents/${id}/password`, params);
}
